import React from 'react';
import '../Text/text.css'
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css'
import { change } from 'redux-form';
import moment from 'moment'

const Text = ({ input, label, type, icon, unit, disabled, meta: { dispatch, form, name, touched, error } }) => {
    const setValue = (date) => {
	dispatch(change(form, input.name, date.toISOString()))
    }
    return (
	
	<div className={['electroInput', ((error) ? 'error' : ''), ((input.value) ? 'touched' : '')].join(" ")} >
	    
	    <div>
		
		<div className="unit">{unit}</div>
		<label htmlFor={input.name}>
		    {label}
		    
		    <span className="errorLabel"> - {error}</span>
		</label>
		<div style={{height: '1px'}}></div>
		<div className="datetime">
		    <Datetime input={false} value={moment(input.value)} onChange={(date) => setValue(date) } inputProps={input} />
		</div>
	    </div>
	</div>
    )
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Inputs/Datetime/index.jsx